import React from "react";
import { useLang, IMAGES } from "../i18n";
import { Reveal, SectionLabel } from "./Motion";
import { Brain, Link2, Radio, Boxes } from "lucide-react";
import { motion } from "framer-motion";

const ICONS = [Brain, Link2, Radio, Boxes];

export const Patent = () => {
  const { t } = useLang();
  const p = t.patent;
  return (
    <section id="patent" data-testid="patent-section" className="relative py-20 md:py-40 bg-[var(--bg-secondary)] border-y border-[var(--border)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-20">
          <div className="lg:col-span-8">
            <SectionLabel>{p.label}</SectionLabel>
            <h2 className="font-cormorant font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl text-[var(--text-primary)]">
              {p.title}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="font-outfit font-light text-[var(--text-secondary)] leading-relaxed">{p.intro}</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* sticky visual */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <div className="relative rounded-2xl overflow-hidden border border-[var(--border)]">
                <img src={IMAGES.macroTag} alt="Smart Label layers" className="w-full h-[520px] object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)]/70 to-transparent" />
                <motion.div
                  animate={{ opacity: [0.3, 1, 0.3] }}
                  transition={{ duration: 2.5, repeat: Infinity }}
                  className="absolute top-6 right-6 flex items-center gap-2 glass rounded-full px-3 py-1.5"
                >
                  <span className="w-2 h-2 rounded-full bg-[var(--green)]" />
                  <span className="font-jetbrains text-[10px] tracking-widest text-[var(--text-primary)]">SCANNING</span>
                </motion.div>
              </div>
            </Reveal>
          </div>

          {/* chapters */}
          <div className="lg:col-span-7 space-y-4">
            {p.chapters.map((c, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="group relative flex gap-6 p-8 rounded-2xl border border-[var(--border)] hover:border-[var(--gold)]/40 bg-[var(--bg-primary)] transition-colors duration-500">
                    <div className="shrink-0">
                      <span className="font-jetbrains text-sm text-[var(--gold)]">{c.n}</span>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <Icon className="w-5 h-5 text-[var(--green)]" />
                        <h3 className="font-cormorant text-2xl md:text-3xl text-[var(--text-primary)]">{c.t}</h3>
                      </div>
                      <p className="font-outfit font-light text-[var(--text-secondary)] leading-relaxed">{c.d}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
